export class IdentificationDocument {
  public static readonly DNI = 1;
  public static readonly CE = 2;
  public static readonly PAS = 3;
  public static readonly cDNI = 'DNI';
  public static readonly cCE = 'CE';
  public static readonly cPAS = 'PAS';
  public static readonly dDNI = 'dni';
  public static readonly dCE = 'ce';
  public static readonly dPAS = 'pas';
}
